import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Stipend Activity Report By Association ")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-5" }
const _hoisted_4 = { class: "row mt-1 w-100 m-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, null, -1)
const _hoisted_6 = {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, null, -1)
const _hoisted_14 = { class: "card mb-5 mb-xl-10" }
const _hoisted_15 = {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_16 = { class: "row mt-1 w-100 m-0" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "div pb-2" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-6 mt-1 text-end\" data-v-54b12dc8=\"\"><button type=\"button\" class=\"btn btn-dark fs-7 p-2 rounded-0\" title=\"Download Xlse\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-excel fs-5\" data-v-54b12dc8=\"\"></i> Excel </button><button type=\"button\" class=\"btn btn-warning fs-7 p-2 rounded-0\" title=\"Download PDF\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-pdf fs-5\" data-v-54b12dc8=\"\"></i> PDF </button><button type=\"button\" class=\"btn btn-primary fs-7 p-2 rounded-0\" title=\"Download CSV\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-csv fs-5\" data-v-54b12dc8=\"\"></i> CSV </button></div>", 1)
const _hoisted_20 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_21 = { class: "collapse show" }
const _hoisted_22 = { class: "card-body border-top p-6" }
const _hoisted_23 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_24 = { class: "table-responsive mt-3" }
const _hoisted_25 = { class: "table table-borderless table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"border-bottom":"1px solid #23ce10"} }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"font-weight":"bold","color":"black"},
      class: "w-25px text-center align-middle border border-gray-400"
    }, " SL "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-center align-middle border border-gray-400",
      style: {"text-align":"center","font-weight":"bold","color":"black"}
    }, " Association "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"font-weight":"bold","color":"black"},
      class: "text-center align-middle border border-gray-400"
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"font-weight":"bold","color":"black"},
      class: "text-center align-middle border border-gray-400"
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"font-weight":"bold","color":"black"},
      class: "text-center align-middle border border-gray-400"
    }, " Total ")
  ])
], -1)
const _hoisted_27 = { style: {} }
const _hoisted_28 = {
  colspan: "5",
  style: {"font-weight":"bold"}
}
const _hoisted_29 = {
  key: 0,
  class: "border border-gray-400 text-center"
}
const _hoisted_30 = {
  style: {"font-weight":"bold","color":"black"},
  colspan: "2",
  class: "text-start"
}
const _hoisted_31 = { style: {"font-weight":"bold","color":"black"} }
const _hoisted_32 = { style: {"font-weight":"bold","color":"black"} }
const _hoisted_33 = { style: {"font-weight":"bold","color":"black"} }
const _hoisted_34 = { class: "border border-gray-400 text-center" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", {
  style: {"font-weight":"bold"},
  colspan: "2",
  class: "text-start"
}, " Total ", -1)
const _hoisted_36 = { style: {"font-weight":"bold","color":"black"} }
const _hoisted_37 = { style: {"font-weight":"bold","color":"black"} }
const _hoisted_38 = { style: {"font-weight":"bold","color":"black"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-lg btn-icon fs-7 p-4",
            title: "Download Xlse",
            "data-v-54b12dc8": "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportTrainee()))
          }, _hoisted_8),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
            title: "Download PDF",
            "data-v-54b12dc8": "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadPdf()))
          }, _hoisted_10),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
            title: "Print",
            "data-v-54b12dc8": "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printPdf()))
          }, _hoisted_12)
        ])
      ]),
      _hoisted_13,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control ps-10 w-200px mt-1 form-control-sm",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
                    onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchItems())),
                    style: {"height":"1em"},
                    placeholder: "Search"
                  }, null, 544), [
                    [_vModelText, _ctx.search]
                  ])
                ])
              ]),
              _hoisted_19
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("table", _hoisted_25, [
                      _hoisted_26,
                      _withDirectives((_openBlock(), _createElementBlock("tbody", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.data, (info, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_28, _toDisplayString(index), 1)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(info), (entity, index2) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: index2,
                                class: "border border-gray-400 text-center"
                              }, [
                                _createElementVNode("td", null, _toDisplayString(index2 + 1), 1),
                                _createElementVNode("td", null, _toDisplayString(entity.entity_short_name), 1),
                                _createElementVNode("td", null, _toDisplayString(entity.total_male), 1),
                                _createElementVNode("td", null, _toDisplayString(entity.total_female), 1),
                                _createElementVNode("td", null, _toDisplayString(entity.total_trainee), 1)
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.total, (sub, index3) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: index3 }, [
                                (index == index3)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                                      _createElementVNode("td", _hoisted_30, " Subtotal(" + _toDisplayString(index3) + ") ", 1),
                                      _createElementVNode("td", _hoisted_31, _toDisplayString(sub?.subtotalmale), 1),
                                      _createElementVNode("td", _hoisted_32, _toDisplayString(sub?.subtotalfemale), 1),
                                      _createElementVNode("td", _hoisted_33, _toDisplayString(sub?.subtotaltrainee), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ], 64))
                        }), 128)),
                        _createElementVNode("tr", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("td", _hoisted_36, _toDisplayString(this.totalmale), 1),
                          _createElementVNode("td", _hoisted_37, _toDisplayString(this.totalfemale), 1),
                          _createElementVNode("td", _hoisted_38, _toDisplayString(this.totaltrainee), 1)
                        ])
                      ])), [
                        [_directive_loading, _ctx.load]
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}